import { useState, useEffect, useCallback, memo } from 'react';
import { Cookies } from 'react-cookie';
import { NavLink } from '../../../node_modules/react-router-dom/dist/index';
import { toast } from 'react-toastify';
import Footer from './FooterComponent';

const cookies = new Cookies();

const Sidebar2 = ({ open, setOpen }) => {
    const [menus, setMenus] = useState([]);

    const getSidebar = useCallback(async () => {

        let Token = cookies.get('token');
        let LoginUserCode = cookies.get('loginUserCode')
        let UserName = cookies.get('userName');
        let SearchText = ''
        let data = { Token, LoginUserCode, UserName, SearchText };
        await fetch('/api/User/GetMenu',
            {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(async (response) => {
                let res = await response.json();
                if (res.status === 'SUCCESS') {
                    setMenus(res.getMenu)
                }
                else if (res.message !== "") {
                    toast.error(res.message, {
                        position: 'top-center'
                    })
                }
            }).catch((err) => {
                toast.error(err.message, {
                    position: 'top-center'
                })
            })

    }, []);



    useEffect(() => {
        if (setOpen) {
            function handleresize() {
                if (window.innerWidth < 1200) {

                    setOpen(false);
                } else {
                    setOpen(true);

                }
            }

            handleresize();

            window.addEventListener("resize", handleresize);

            return () => window.addEventListener("resize", handleresize);
        }
    }, [])


    useEffect(() => {
        getSidebar()
    }, []);

    return (
        <>
            <aside id="sidebar" className="sidebar" style={open ? {} : { left: "-250px" }}>
                <ul className="sidebar-nav" id="sidebar-nav">
                    {menus !== null ?
                        (menus.map((menu, index) => (
                            <li className="nav-item" key={index}>
                                {menu.getSubMenu !== null ?
                                    (
                                        <>
                                            <div
                                                className={`nav-link collapsed cursor-pointer`}
                                                data-bs-target={`#${(menu.menuText).replaceAll(' ', '').replaceAll('&', '') }`}
                                                data-bs-toggle="collapse"
                                            >
                                                <i className={menu.cssClass} />
                                                <span>{menu.menuText}</span>
                                                <i className="bi bi-chevron-down ms-auto" />
                                            </div>

                                            <ul
                                                id={`${(menu.menuText).replaceAll(' ', '').replaceAll('&','')}`}
                                                className={`nav-content collapse open sidebar-submenu ${menu.getSubMenu[0].mpageID === localStorage.getItem('ID') ? 'show' : ''}`}
                                                data-bs-parent="#sidebar-nav"
                                            >
                                                {menu.getSubMenu.map((subMenu, i) => (
                                                    <li key={i} className='mx-2 my-1' onClick={() => localStorage.setItem('ID', subMenu.mpageID)}>
                                                        <NavLink to={`/${(subMenu.pageUrl)}`}
                                                            id={subMenu.pageID}>
                                                            <i className={subMenu.cssClass} />
                                                            <span>{(subMenu.menuText).trim()}</span>
                                                        </NavLink>
                                                    </li>
                                                ))}
                                            </ul>
                                        </>
                                    ) : (
                                        <NavLink
                                            className="nav-link collapsed"
                                            cursor-pointer
                                            key={index}
                                            to={`/${menu.pageUrl}`}
                                        >
                                            <i className={menu.cssClass} />
                                            <span>{menu.menuText}</span>
                                            <i className="bi bi-chevron-down ms-auto" />
                                        </NavLink>)}
                            </li>
                        ))) : ("")}
                </ul>
            </aside>
            <Footer/>
        </>
    )
}
export default memo(Sidebar2)


